// extracted by mini-css-extract-plugin
module.exports = {"announcements":"P_fr p-2","announcement":"P_fs card my-2","announcement--highlighted":"P_ft","announcement__list-item":"P_fv py-1","announcement__flag":"P_fw"};